<template>
    <v-container fluid>
        <v-container fluid v-if="!exists_kpi">
            <v-btn rounded style="display: block; margin: auto;" @click="gerarNova" class="error mt-4 mb-4 elevation-8" x-large>
                Gerar nova diária KPI
            </v-btn>
        </v-container>
        <v-container fluid v-else>            
            <MiniAlerts style="white-space: pre-line" v-if="alert.showAlert" :message="alert.message" />
            <validation-observer ref="form" v-slot="{ invalid }">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-menu
                                v-if="method == 'create'"
                                v-model="menu0"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="d-none d-lg-block"
                                    :disabled="inside_diary"
                                    v-model="fields.data"
                                    label="Insira Data"
                                    outlined dense
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                <v-text-field 
                                    class="d-block d-lg-none" 
                                    v-model="fields.data" 
                                    :disabled="inside_diary"
                                    type="date" 
                                    id="birthday" 
                                    label="Insira data"
                                    dense outlined
                                    :max="new Date(new Date()+1).toISOString().substr(0, 10)"
                                />
                                </template>
                                <v-date-picker
                                    :allowed-dates="(date) => date <= new Date(new Date()+1).toISOString().substr(0, 10)"
                                    v-model="fields.data"
                                    @input="menu0 = false"
                                    @change="dataChanged(); diaryExists();"
                                ></v-date-picker>
                            </v-menu>
                            <v-text-field
                                v-else
                                dense outlined
                                v-model="fields.data"
                                disabled
                                label="Data"
                            />
                        </v-col>
                        <v-col cols="12" md="4" v-if="fields.data != null">
                            <validation-provider v-slot="{ errors }" vid="Obras" name="Obras" rules="required">
                                <v-autocomplete
                                    :disabled="method == 'update' || inside_diary"
                                    v-model="fields.obra_id"
                                    :items="obras"
                                    outlined dense
                                    :item-text="item => item.Codigo + ' - ' + item.Descricao"
                                    item-value="Id"
                                    :error-messages="errors"
                                    label="Obras *"
                                    @change="changeWork(); diaryExists();"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                    <v-row v-if="showContent">
                        <v-col cols="12">
                            <v-simple-table class="d-none d-lg-block">
                                <template v-slot:default>
                                    <thead class="primary">
                                        <tr>
                                            <th v-if="classeNeeded == false" width="25%" class="text-center white--text text-caption font-weight-bold">
                                                Frente Obra
                                            </th>
                                            <th width="25%" class="text-center white--text text-caption font-weight-bold">
                                                Nome UO
                                            </th>
                                            <th v-if="showNature" width="15%" class="text-center white--text text-caption font-weight-bold">
                                                Natureza
                                            </th>
                                            <th v-if="showNature" width="12%" class="text-center white--text text-caption font-weight-bold">
                                                Unidade
                                            </th>
                                            <th width="15%" class="text-center white--text text-caption font-weight-bold">
                                                Produção
                                            </th>
                                            <th class="text-center white--text text-caption font-weight-bold">
                                                Notas
                                            </th>
                                            <th class="text-center white--text text-caption font-weight-bold">
                                                ...
                                            </th>
                                            <th class="text-center white--text text-caption font-weight-bold">
                                                Opções
                                            </th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th colspan="6">
                                                <v-row>
                                                    <v-col cols="12" md="auto">
                                                        <v-checkbox
                                                            dense outlined
                                                            label="Dividir horas de Mão Obra"
                                                            v-model="fields.divideAllHours"
                                                        />
                                                    </v-col>
                                                    <v-col cols="12" md="auto">
                                                        <v-checkbox
                                                            dense outlined
                                                            label="Dividir horas de Máquinas"
                                                            v-model="fields.divideAllMachines"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in getLines" :key="item.id"
                                        >
                                            <td v-if="classeNeeded == false">
                                                <validation-provider v-slot="{ errors }" :vid="`Frentes_${item.id}`" name="Frentes" rules="required">
                                                    <v-autocomplete
                                                        v-model="item.obra_frente_id"
                                                        :items="frentes_obra"
                                                        outlined dense
                                                        :item-text="ob => getText(ob)"
                                                        item-value="ID"
                                                        class="mt-4"
                                                        :error-messages="errors"
                                                        label="Frentes de Obra *"
                                                        @change="changedFrente(item)"
                                                    />
                                                </validation-provider>
                                            </td>
                                            <td>
                                                <validation-provider v-slot="{ errors }" :vid="`Classe_${item.id}`" name="Classe" rules="required">
                                                    <v-autocomplete
                                                        v-if="mqt != null"
                                                        class="mt-4"
                                                        dense outlined
                                                        :value="item.classe_id"
                                                        :items="item.available_classes"
                                                        :error-messages="errors"
                                                        clearable
                                                        :item-text="item => item.Descricao"
                                                        item-value="ID"
                                                        label="Classe *"
                                                        @change="val => updateClasseId(index, val)"
                                                    />
                                                </validation-provider>
                                            </td>
                                            <td v-if="showNature">
                                                <validation-provider v-slot="{ errors }" :vid="`Natureza_${item.id}`" name="Natureza" rules="required">
                                                    <v-autocomplete
                                                        v-model="item.natureza_id"
                                                        :error-messages="errors"
                                                        :items="natureza_trabalhos"
                                                        :item-text="item=>item.code + ' - ' + item.natureza + ' (' + item.unidade + ')'"
                                                        dense outlined
                                                        item-value="id"
                                                        label="Natureza *"
                                                        class="mt-4"
                                                        @change="onNaturezaChanged(item)"
                                                    />
                                                </validation-provider>
                                            </td>
                                            <td v-if="showNature">
                                                <validation-provider v-slot="{ errors }" :vid="`Unidade_${item.id}`" name="Unidade" rules="required">
                                                    <v-autocomplete
                                                    class="mt-4"
                                                    dense
                                                    outlined
                                                    clearable
                                                    :disabled="!item.natureza_id"
                                                    v-model="item.id_lista_unidades"
                                                    :items="getUnidadesForLine(item)"
                                                    item-text="abreviacao"
                                                    item-value="id"
                                                    :error-messages="errors"
                                                    label="Unidade *"
                                                    />
                                                </validation-provider>
                                            </td>
                                            <td>
                                                <validation-provider v-slot="{ errors }" :vid="`Producao_${item.id}`" name="Produção" rules="required">
                                                    <v-text-field
                                                        label="Produção *"
                                                        class="mt-4"
                                                        dense outlined
                                                        :error-messages="errors"
                                                        clearable
                                                        v-model="item.producao"
                                                        type="number"
                                                    />
                                                </validation-provider>
                                            </td>                                     
                                            <td>
                                                <validation-provider v-slot="{ errors }" :vid="`Local_${item.id}`" name="Local" rules="">
                                                    <v-text-field
                                                        class="mt-4"
                                                        dense outlined
                                                        label="Nota"
                                                        placeholder="Insira nota"
                                                        v-model="item.notas"
                                                        @click="openEditorModal(item)"   
                                                    />
                                                </validation-provider>
                                            </td>
                                            <td>
                                                <v-row no-gutters justify="center" align="center">
                                                    <v-col cols="12" justify="center" align="center">
                                                        <v-btn :disabled="item.classe_id == null" class="primary" x-small rounded @click="maoObraDialog.line = item; maoObraDialog.show = false; maoObraDialog.show = true;">
                                                            Mão Obra
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" justify="center" align="center">
                                                        <v-btn :disabled="item.classe_id == null || loadingMaquinas" class="primary" x-small rounded @click="eqDialog.line = item; eqDialog.show = false; eqDialog.show = true;">
                                                            {{ loadingMaquinas ? 'a carregar máquinas' : 'Máquinas'}}
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td>
                                                <v-btn
                                                    dark
                                                    x-small
                                                    fab
                                                    color="error"
                                                    @click="deleteLine(item.id)"
                                                    >
                                                    <v-icon x-small>mdi-delete</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>

                        </v-col>
                        <v-col cols="12" align="center">
                            <v-btn fab @click="addLineToTable" class="primary">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>  
                    <v-row v-if="inside_diary" class="ma-0 pa-0">
                        <!-- LISTAGEM MATERIAIS -->
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-card elevation="0">
                                <v-card-title class="primary white--text">
                                    {{loadedMaterials ? 'Materiais' : 'A carregar materiais...'}}
                                </v-card-title>
                                <v-card-text class="mt-2">
                                    <v-row :key="reloadMateriaisKey">
                                        <v-col cols="12" v-for="(naturezas, classe) in groupedMaterials" :key="classe">
                                        <h3 class="font-weight-bold">{{ classe }}</h3>
                                        <div v-for="(materiais, natureza) in naturezas" :key="classe + natureza" class="ml-4">
                                            <h4 class="font-italic">{{ natureza }}</h4>
                                            <ul class="ml-4">
                                                <li v-for="(material, idx) in materiais" :key="material.id">
                                                    <strong>{{ material.unidade }}</strong> — {{ material.descricao }}

                                                    <v-row dense class="mt-1" align="center">
                                                        <v-col cols="12">
                                                            <v-text-field
                                                                v-model="material.qty"
                                                                dense outlined
                                                                hide-details
                                                                type="number"
                                                                label="Quantidade"
                                                                style="max-width: 100px;"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </li>
                                            </ul>
                                        </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-if="inside_diary" class="ma-0 pa-0">
                        <!-- LISTAGEM SUBEMPREITADAS -->
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-card elevation="0">
                                <v-card-title class="primary white--text">
                                    {{loadedSubempreitadas ? 'Subempreitadas' : 'A carregar subempreitadas...'}}
                                </v-card-title>
                                <v-card-text class="mt-2">
                                    <v-row :key="reloadSubempreitadasKey">
                                        <v-col cols="12" v-for="(naturezas, classe) in groupedSubempreitadas" :key="classe">
                                        <h3 class="font-weight-bold">{{ classe }}</h3>
                                        <div v-for="(subempreitadas, natureza) in naturezas" :key="classe + natureza" class="ml-4">
                                            <h4 class="font-italic">{{ natureza }}</h4>
                                            <ul class="ml-4">
                                                <li v-for="(subempreitada, idx) in subempreitadas" :key="subempreitada.id">
                                                    {{ subempreitada.descricao }}

                                                    <v-row dense class="mt-1" align="center">
                                                        <v-col cols="12">
                                                            <v-text-field
                                                                v-model="subempreitada.qty"
                                                                dense outlined
                                                                hide-details
                                                                type="number"
                                                                label="Quantidade"
                                                                style="max-width: 100px;"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </li>
                                            </ul>
                                        </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-if="showContent && inside_diary == false" class="mt-4">
                        <v-col cols="12" align="end">
                            <v-btn :disabled="invalid" type="submit" class="success" rounded>
                                Gravar<v-icon class="ml-2">mdi-content-save</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>          
                </v-form>
            </validation-observer>
        </v-container>

        <v-dialog
            v-if="editorModal"
            v-model="editorModal"
            max-width="600px"
            scrollable
        >
            <InputEditorModal @change-value="changeEditorModal" vid="editor_local" :title="'Nota'" :label="'Nota'" v-model="inputEditorModalData.itemModel"/>
        </v-dialog>

        <DialogSuccess :opened="success" @on-ok="onSuccess" >
            Diária gravada com sucesso
        </DialogSuccess>

        <DialogConfirmation 
            v-if="confirmationModal.show"
            :title="confirmationModal.title" 
            type="warning" 
            :opened="confirmationModal.show" 
            :elevation="0"
            @on-submit="moveToDiary" 
            @on-cancel="reloadWindow">
                {{ confirmationModal.message }}
        </DialogConfirmation>

        <MaoObraDialog 
            v-if="maoObraDialog.show" 
            :all_workers="all_workers" 
            :external_workers="fields_diary.funcionariosExternos"
            :all_external_workers="all_external_workers"
            :workers="workers" 
            :divideAllHours="fields.divideAllHours"
            :total_lines="getLines.length"
            :line="maoObraDialog.line" 
            ref="maoObraDialogRef"
            @close="maoObraDialog.show = false"
        />

        <EQDialog v-if="eqDialog.show" 
            :all_equipamentos="all_equipamentos" 
            :equipamentos="fields_diary.equipamentosInternos"
            :equipamentos_externos="fields_diary.equipamentosExternos"
            :line="eqDialog.line"
            :divideAllMachines="fields.divideAllMachines"
            :total_lines="getLines.length"
            ref="eqDialogRef"
            @close="eqDialog.show = false"
        />

    </v-container>
</template>
<script>
import DateInput from "@/components/UI/Inputs/DateInput"
import InputEditorModal from "@/components/UI/Modals/InputEditorModal";
import Obra from "@/api/Obra.js"
import FrenteObra from "@/api/FrenteObra.js"
import UnidadesObra from "@/api/UnidadesObra.js"
import Materiais from "@/api/Materiais.js"
import DiaryKPI from "@/api/DiaryKPI.js"
import Classe from "@/api/Classe.js"
import SubEmpreitada from "@/api/SubEmpreitada.js"
import dayjs from 'dayjs'
import ErrorSnackbar from "@/components/UI/Snackbars/ErrorSnackbar";
import ConfirmModal from '@/components/Modals/ConfirmModal.vue';
import SuccessSnackbar from "@/components/UI/Snackbars/SuccessSnackbar";
import Loader from "@/components/UI/Loaders/Loader";
import MiniAlerts from '@/components/Alerts/MiniAlerts.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import DialogSuccess from '@/components/UI/DialogSuccess.vue';
import DialogConfirmation from '@/components/UI/DialogConfirmation.vue';
import NaturezaTrabalhos from '@/api/NaturezaTrabalhos.js'
import MaoObraDialog from '@/components/Diaries/Kpi/Dialogs/MaoObraDialog.vue'
import EQDialog from '@/components/Diaries/Kpi/Dialogs/EQDialog.vue'

export default{
    name:"DiaryKPI",
    components:{
        MaoObraDialog,
        DateInput,
        DialogSuccess,
        InputEditorModal,
        ErrorSnackbar,
        ConfirmModal,
        SuccessSnackbar,
        Loader,
        MiniAlerts,
        DialogConfirmation,
        Tooltip,
        EQDialog
    },
    props:{
        method: String,
        diary: Object,
        inside_diary: {
            typeof: Boolean,
            default: false
        },
        fields_diary:{
            typeof: Object,
            default: null
        },
        workers:{
            typeof: Array,
            default: []
        },
        all_workers:{
            typeof: Array,
            default: []
        },
        all_external_workers:{
            typeof: Array,
            default: []
        }
    },
    watch: { 
        'fields_diary.subempreitadas': {
            deep: true,
            handler(novas) {
            console.log('Atualizou fields_diary.subempreitadas:', novas);
            
            this.fields = {
                ...this.fields,
                subempreitadas: JSON.parse(JSON.stringify(novas))
            };

            this.reloadSubempreitadasKey++;
            }
        },
        diary: {
            immediate: true, 
            handler (val) {
                if(!val) {
                    return;
                }
        
                let data = {...val};
        
                this.fields = data;

                console.log("AQUI")
                console.log(this.fields)

                this.line = this.fields.lines
                // garantir defaults de unidade nas linhas quando há natureza
                this.line.forEach(l => {
                if (!l.natureza_id) return;

                // se não veio preenchido do backend e só existe 1 unidade
                if (!l.id_lista_unidades) {
                    const nat = this.natureza_trabalhos.find(n => n.id === l.natureza_id);
                    if (nat?.lista_unidades?.length === 1) {
                    this.$set(l, 'id_lista_unidades', nat.lista_unidades[0].id);
                    }
                }
                });

                this.fields.frente_id = data.obra_frente_id
                this.fields.materials = data.materials

                this.loadingContent = 0

                this.changeWork()

                if(this.fields.frente_id == null)
                    this.hideFrentes = true

                
                this.classesPorObra()

                this.showContent = true

                if(this.fields.id != undefined)
                    this.exists_kpi = true;
            }
        },
    },
    data(){
        return{
            exists_kpi: false,
            loadedMaterials: false,
            loadedSubempreitadas: false,
            subempreitadas_array: [],
            fieldsKey: 0,
            loadingMaquinas: true,
            eqDialog:{
                line: null,
                show: false
            },
            maoObraDialog: {
                line: null,
                show: false
            },
            editorModal: false,
            menu0: false,
            menu1: false,
            menu2: false,
            classeNeeded: false,
            natureza_trabalhos: [],
            confirmationModal: {
                show: false,
                title: '',
                message: '',
                item: null
            },
            alert:{
                showAlert: false,
                message: ''
            },
            loadingContent: 2,
            reloadSubempreitadasKey: 30000,
            hideFrentes: false,
            error: false,
            timeout: 2000,
            error_message: "",
            showContent: false,
            editorModal:false,
            success: false,
            loader: false,
            mqt: null,
            inputEditorModalData:{
                itemModel:null,
                id: null,
            },  
            fields:{
                obra_id: null,
                frente_id: null,
                classe_id: null,
                data: null,
                belongs_to_diary: null,
                diary_creator: null,
                divideAllHours: false,
                divideAllMachines: false,
                materials:[],
                subempreitadas: [],
                lines: [
                    {
                        id: dayjs().unix() + '-new',
                        classe_id: null,
                        id_lista_unidades: null,
                        producao: null,
                        notas: null,
                        linhas_mo_internal: [],
                        linhas_mo_external: [],
                        linhas_eq_internal: [],
                        linhas_eq_external: []
                    }
                ]
            },
            deletedLines: [],
            line: [
                {
                    id: dayjs().unix() + '-new',
                    classe_id: null,
                    producao: null,
                    id_lista_unidades: null,
                    notas: null,
                    linhas_mo_internal: [],
                    linhas_mo_external: [],
                    linhas_eq_internal: [],
                    linhas_eq_external: []
                }
            ],
            obras: [],
            classes:[],
            frentes_obra: [],
            all_equipamentos: [],
            materiais: [],
            reloadMateriaisKey: 9000,
        }
    },
    async mounted(){
        await this.fillBaseData()

        this.prePreenchimento()

        this.showContent = true
    },
    methods:{  
        getNaturezaById(id) {
            if (!id) return null;
            return this.natureza_trabalhos.find(n => n.id === id) || null;
            },

        getUnidadesForLine(line) {
            const nat = this.getNaturezaById(line.natureza_id);
            return nat?.lista_unidades || [];
        },

        onNaturezaChanged(line) {
            // reset ao mudar a natureza
            this.$set(line, 'id_lista_unidades', null);

            const unidades = this.getUnidadesForLine(line);

            // se só há 1 unidade, fica automaticamente
            if (unidades.length === 1) {
                this.$set(line, 'id_lista_unidades', unidades[0].id);
            }
        },
        gerarNova(){
            this.exists_kpi = true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                this.$refs.form?.reset();
                });
            });
        },
        changedFrente(item){
            let classes = []
            this.frentes_obra.forEach(element => {
                if(element.ID == item.obra_frente_id)
                    classes= element.classes
            });

            this.$set(item, 'available_classes', classes)
        },
        reloadSubempreitadas(){
            this.fields_diary.subempreitadas = JSON.parse(JSON.stringify(this.fields_diary.subempreitadas))

            this.reloadSubempreitadasKey++
        },
        reloadMateriais(){
            // Cria uma nova referência — força o Vue a reavaliar o computed
            this.fields.materials = JSON.parse(JSON.stringify(this.fields.materials));

            // Opcional, apenas se quiseres que o DOM se redesenhe via :key
            this.reloadMateriaisKey++;
        },
        getMaterial(item){
            return this.materiais.find(material => material.id === item.material);
        },
        updateClasseId(index, val) {
            this.$set(this.line[index], 'classe_id', val);
            this.fieldsKey++;
        },
        getText(ob) {
            if (ob.Descricao && ob.SubEmp && ob.Descricao.includes(ob.SubEmp)) {
                return ob.Descricao;
            }

            return `${ob.SubEmp} - ${ob.Descricao}`;
        },
        async prePreenchimento(index = null) {
            const lines = index !== null ? [this.fields.lines[index]] : this.fields.lines;
            if(lines == null)
                return
            if(lines == undefined)
                return 

            for (const element of lines) {
                this.maoObraDialog.line = element;
                this.maoObraDialog.show = true;

                await this.$nextTick(); // garante que o diálogo renderizou

                const result = await this.$refs.maoObraDialogRef.save(); // precisa devolver uma Promise

                this.maoObraDialog.show = false;
                await this.$nextTick();
            }

            for (const element of lines) {
                this.eqDialog.line = element;
                this.eqDialog.show = true;

                await this.$nextTick(); // garante que o diálogo renderizou

                const result = await this.$refs.eqDialogRef.save(); // precisa devolver uma Promise

                this.eqDialog.show = false;
                await this.$nextTick();
            }
        },
        moveToDiary(){
            this.$router.push('/kpi/edit/' + this.confirmationModal.item)
        },
        reloadWindow(){
            window.location.reload()
        },
        diaryExists(){
            if(this.fields.data == null) return
            if(this.fields.obra_id == null) return

            let data = {
                data: this.fields.data,
                obra_id: this.fields.obra_id,
                classe_id: this.fields.classe_id,
                frente_id: this.fields.frente_id
            }

            DiaryKPI.checkIfExists(data).then((resp)    =>  {
                if(resp.data.msg == true){
                    this.confirmationModal.title = "Diária já existe!"
                    this.confirmationModal.message = "Esta diária já existe. Pretende editar?"
                    this.confirmationModal.item = resp.data.id
                    this.confirmationModal.show = true
                }
            })
        },
        async fillBaseData(){
            let data = {
                tipo: 'O'
            }
            
            await Obra.all(data).then((resp)   =>  {
                this.obras = resp.data;
            });

            NaturezaTrabalhos.all().then((resp) =>  {
                this.natureza_trabalhos = resp.data
            })

            if(this.inside_diary){
                this.fields.data = this.fields_diary.Data
                this.fields.obra_id = this.fields_diary.obra_id
                this.dataChanged()
                this.changeWork()
                this.fields.belongs_to_diary = this.fields_diary.id
            }

            data = {
                work_id: this.fields.obra_id,
                codigo: this.$store.state.user.data.funcionario.Codigo,
                data: this.fields.Data,
                place: 'encarregado'
            }

            Obra.getObraEquipamentos(data).then((resp)  =>  {
                this.all_equipamentos = resp.data
                this.loadingMaquinas = false
            })

            let materialsData ={
                id_frente_obra: "null",
                id_obra_classe: "null",
                obra_id: this.fields.obra_id
            }

            await Materiais.getList(materialsData).then((resp)    =>  {
                this.materiais = resp.data
                this.loadedMaterials = true
            })

            if(this.fields.obra_id != null){
                await SubEmpreitada.all(this.fields.obra_id).then((resp)   =>  {
                    this.subempreitadas_array = resp.data
                    this.loadedSubempreitadas = true
                })
            }
        },  
        deleteLine(){
            if(this.line.length == 1){
                this.error_message = "Não pode apagar a única linha que tem"
                this.error = true
                return
            }
                
            let index = this.line.findIndex(item => item.id == id);

            this.line.splice(index, 1);

            if(!id.includes('new'))
                this.deletedLines.push(id)
        },
        onSuccess(){
            if(this.method == 'update'){
                window.location.reload()
                return
            }

            this.success = false;
            this.$router.push('/kpi/lista-de-diarios')
        },
        linhasValidas(){
            let errors = {
                valid: true,
                message: []
            }

            this.fields.lines.forEach(linha => {
                let ha_nulos = false

                linha.linhas_eq_external.forEach(element => {
                    if(element.hours == null) ha_nulos = true
                });   
                linha.linhas_eq_internal.forEach(element => {
                    if(element.hours == null) ha_nulos = true
                });     
                linha.linhas_mo_external.forEach(element => {
                    if(element.hours == null) ha_nulos = true
                });             
                linha.linhas_mo_internal.forEach(element => {
                    if(element.hours == null) ha_nulos = true
                });

                let aux_divideAllHours = this.fields.hasOwnProperty('divideAllHours') ? this.fields.divideAllHours : false;
                let aux_divideAllMachines = this.fields.hasOwnProperty('divideAllMachines') ? this.fields.divideAllMachines : false;

                let ambos_true = (aux_divideAllHours === true && aux_divideAllMachines === true);
                if(!ambos_true){
                    if(ha_nulos){
                        errors.valid = false
                        let aux_classe = this.classes.find(c => c.ID === linha.classe_id);
                        let aux_natureza = this.natureza_trabalhos.find(c => c.id === linha.natureza_id);
                        errors.message.push({
                            classe: aux_classe,
                            natureza: aux_natureza
                        })
                    }
                }
            });
            return errors
        },
        async getData(diary_hash = null, diary_creator = null){
            this.fields.lines = this.line
            this.fields.deletedLines = this.deletedLines

            if(diary_hash != null){
                this.fields.belongs_to_diary = diary_hash
                this.fields.diary_creator = diary_creator
            }

            let valid = this.linhasValidas()
            if(valid.valid == false)
                return valid

            // Verificar se há divisão de horas
            if(this.fields.divideAllHours){

                for (const element of this.fields.lines) {
                    this.maoObraDialog.line = element;
                    this.maoObraDialog.show = true;

                    await this.$nextTick(); // garante que o diálogo renderizou

                    const result = await this.$refs.maoObraDialogRef.save(); // precisa devolver uma Promise

                    this.maoObraDialog.show = false;
                    await this.$nextTick();
                }
            }

            if(this.fields.divideAllMachines){

                for (const element of this.fields.lines) {
                    this.eqDialog.line = element;
                    this.eqDialog.show = true;

                    await this.$nextTick(); // garante que o diálogo renderizou

                    const result = await this.$refs.eqDialogRef.save(); // precisa devolver uma Promise

                    this.eqDialog.show = false;
                    await this.$nextTick();
                }
            }

            // Construir lista de materiais com qty
            const materiais = []
            for (const [classeLabel, naturezas] of Object.entries(this.groupedMaterials)) {
                for (const [naturezaLabel, lista] of Object.entries(naturezas)) {
                    for (const mat of lista) {
                        if (mat.qty != null && mat.qty !== '') {
                            materiais.push({
                                material: mat.material.artigo,
                                classe_id: mat.classe.ID,
                                natureza_id: mat.natureza.id,
                                unidade: mat.unidade,
                                quantidade: mat.qty == null ? 0 : mat.qty
                            })
                        }
                    }
                }
            }


            this.fields.materials = materiais

            // Construir lista de subempreitadas com qty
            const subempreitadas = []
            for (const [classeLabel, naturezas] of Object.entries(this.groupedSubempreitadas)) {
                for (const [naturezaLabel, lista] of Object.entries(naturezas)) {
                    for (const mat of lista) {
                        if (mat.qty != null && mat.qty !== '') {
                            console.log(mat)
                            subempreitadas.push({
                                subempreitada: mat.subempreitada.Id,
                                classe_id: mat.classe.ID,
                                natureza_id: mat.natureza.id,
                                quantidade: mat.qty == null ? 0 : mat.qty
                            })
                        }
                    }
                }
            }
            this.fields.subempreitadas = subempreitadas



            return this.fields
        },
        async submit(diary_hash = null, diary_creator = null){
            this.fields.lines = this.line
            this.fields.deletedLines = this.deletedLines

            if(diary_hash != null){
                this.fields.belongs_to_diary = diary_hash
                this.fields.diary_creator = diary_creator
            }
            
            await DiaryKPI[this.method](this.fields, this.fields.id).then((resp)  =>  {                
                this.success = true
            })            
        },
        changeEditorModal(e){
            this.line.forEach(element => {
                if(element.id == this.inputEditorModalData.id)
                    element.notas = e
            });
        },   
        openEditorModal(item){
            this.inputEditorModalData.itemModel = item.local
            this.inputEditorModalData.id = item.id
            this.editorModal=true
        },
        dataChanged(){
            if(this.obras.length == 1){
                this.fields.obra_id = this.obras[0].Id
                this.changeWork()
            }
        },
        deleteLine(id){
            if(this.line.length == 1){
                if(this.method == 'create'){
                    this.exists_kpi = false;
                    return;
                }
                this.error_message = "Não pode apagar a única linha que tem"
                this.error = true
                return
            }
                
            let index = this.line.findIndex(item => item.id == id);

            this.line.splice(index, 1);

            if(!id.includes('new'))
                this.deletedLines.push(id)
        },
        changeFrenteObra(){
            if(this.fields.obra_id == null)
                return

            if(this.fields.frente_id == null)
                return

            let frente = null
            this.frentes_obra.forEach(element => {
                if(element.ID == this.fields.frente_id)
                    frente = element
            });

            if(frente != null){
                if(frente.classes.length > 0){
                    this.classes = frente.classes
                    this.classeNeeded = true
                }else 
                    this.showContent = true
            }

            this.showContent = true
            
        },
        addLineToTable(){
            this.line.push({
                id: dayjs().unix() + '-new',
                classe_id: null,
                natureza_id: null,
                id_lista_unidades: null,
                producao: null,
                available_classes: this.classes,  
                notas: null,
                linhas_mo_internal: [],
                linhas_mo_external: [],
                linhas_eq_internal: [],
                linhas_eq_external: []
            })
        }, 
        changeWork(){
            let ObraPai = null
            // Vou obter o ObraPai que é o código da obra, para obter a sua frente
            // Códigos exemplo: 0110203 é da obra MOLHE SINES 3ª F
            // Vamos à tabela ObraFrente ver quais as obras que têm esse código
            this.obras.forEach(element => {
                if(element.Id == this.fields.obra_id)
                    ObraPai = element.Codigo
            });

            FrenteObra.all(ObraPai).then((resp) =>  {
                this.frentes_obra = resp.data

                this.line.forEach(element => {
                    this.frentes_obra.forEach(f => {
                        if(element.obra_frente_id == f.ID)
                            element.available_classes = f.classes
                    });
                });

                if(this.frentes_obra.length == 0){
                    this.classeNeeded = true  
                    this.classesPorObra()
                }else{
                    if(this.frentes_obra.length == 1){
                        this.fields.frente_id = this.frentes_obra[0].ID

                        this.changeFrenteObra()
                    }
                }
            })
            
            let data = {
                get_object: true
            }
            UnidadesObra.findByWork(this.fields.obra_id, data).then((resp)    =>  {
                this.mqt = resp.data
            })

            if(this.method == 'create'){
                SubEmpreitada.all(this.fields.obra_id).then((resp)   =>  {
                    this.subempreitadas_array = resp.data
                    this.loadedSubempreitadas = true
                })
            }
        },
        classesPorObra(){
            
            // Também temos de verificar se esta obra tem classes
            Classe.getClassesByObraPai(this.fields.obra_id).then((resp) =>  {
                this.classes = resp.data

                if(this.classeNeeded){
                    this.line.forEach(element => {
                        element.available_classes = this.classes
                    });
                }
                
                if(this.classes == 0){
                    this.showContent = true
                    return
                }
                if(this.classes.length == 1){
                    this.fields.classe_id = this.classes[0].ID

                    this.changeClasse()
                }

                if(this.classes.length > 0){
                    this.showContent = true
                }
            })
        },
        changeClasse(){
            if(this.fields.obra_id == null)
                return
            
            if(this.fields.classe_id == null)
                return

            this.showContent = true
        }
    },
    computed:{
        getSubempreitadasList(){
            const resultado = [];
            this.fields.subempreitadas.forEach(subempreitada => {
                this.getLines.forEach(linha_kpi => {
                    if (subempreitada.classe_id === linha_kpi.classe_id && linha_kpi.natureza_id !== undefined) {
                        
                        const subempreitadaObj = this.subempreitadas_array.find(m => m.Id === subempreitada.subempreitada_id);
                        const naturezaObj = this.natureza_trabalhos.find(n => n.id === subempreitada.natureza_id);
                        const classeObj = this.classes.find(c => c.ID === subempreitada.classe_id);

                        if (!subempreitadaObj || !naturezaObj || !classeObj) return;


                        // Verifica se já existe na lista (evita duplicados)
                        const exists = resultado.some(r =>
                            r.subempreitada.Id === subempreitadaObj.Id &&
                            r.natureza.id === naturezaObj.id &&
                            r.classe.ID === classeObj.ID
                        );

                        let existe = false
                        this.fields_diary.subempreitadas.forEach(existence => {
                            console.log(existence)
                            if(existence.subempreitada === subempreitada.subempreitada_id)
                                if(existence.classe_id_inteiro == subempreitada.classe_id)
                                    existe = true
                        });
                        

                        if (!exists) {
                            if(existe){
                            resultado.push({
                                subempreitada: subempreitadaObj,
                                natureza: naturezaObj,
                                classe: classeObj,
                                producao: linha_kpi.producao,
                                qty: subempreitada.qty
                            });
                        }
                        }
                    }
                });
            });
            this.fields_diary.subempreitadas.forEach(subempreitada => {
                this.getLines.forEach(linha_kpi => {
                    this.classes.forEach(element => {
                        if(element.ClasseId == subempreitada.classe_id)
                            subempreitada.classe_id_inteiro = element.ID
                    });
                    
                    if (subempreitada.classe_id_inteiro === linha_kpi.classe_id && linha_kpi.natureza_id !== undefined) {
                        const subempreitadaObj = this.subempreitadas_array.find(m => m.Id === subempreitada.subempreitada);
                        const naturezaObj = this.natureza_trabalhos.find(n => n.id === linha_kpi.natureza_id);
                        const classeObj = this.classes.find(c => c.ID === linha_kpi.classe_id);


                        

                        if (!subempreitadaObj || !naturezaObj || !classeObj) return;

                        // Verifica se já existe na lista (evita duplicados)
                        const exists = resultado.some(r =>
                            r.subempreitada.Id === subempreitadaObj.Id &&
                            r.natureza.id === naturezaObj.id &&
                            r.classe.ID === classeObj.ID
                        );

                        let quantidade = null

                        if (!exists) {
                            resultado.push({
                                subempreitada: subempreitadaObj,
                                natureza: naturezaObj,
                                classe: classeObj,
                                producao: linha_kpi.producao,
                                qty: null
                            });
                        }
                    }
                });
            });

            return resultado;
        },
        getMaterialsList() {
            const resultado = [];
            this.fields.materials.forEach(material => {
                this.getLines.forEach(linha_kpi => {
                    if (material.classe_id === linha_kpi.classe_id && linha_kpi.natureza_id !== undefined) {
                        
                        const materialObj = this.materiais.find(m => m.artigo === material.artigo);
                        const naturezaObj = this.natureza_trabalhos.find(n => n.id === material.natureza_id);
                        const classeObj = this.classes.find(c => c.ID === material.classe_id);

                        if (!materialObj || !naturezaObj || !classeObj) return;

                        // Verifica se já existe na lista (evita duplicados)
                        const exists = resultado.some(r =>
                            r.material.id === materialObj.id &&
                            r.natureza.id === naturezaObj.id &&
                            r.classe.ID === classeObj.ID
                        );

                        let existe = false
                        this.fields_diary.materiais.forEach(existence => {
                            if(existence.codigo_artigo === material.artigo)
                                if(existence.classe_id == material.classe_id)
                                    existe = true
                        });

                        if (!exists) {
                            if(existe){
                            resultado.push({
                                material: materialObj,
                                natureza: naturezaObj,
                                classe: classeObj,
                                producao: linha_kpi.producao,
                                qty: material.qty
                            });
                        }
                        }
                    }
                });
            });

            this.fields_diary.materiais.forEach(material => {
                this.getLines.forEach(linha_kpi => {
                    if (material.classe_id === linha_kpi.classe_id && linha_kpi.natureza_id !== undefined) {
                        const materialObj = this.materiais.find(m => m.id === material.material);
                        const naturezaObj = this.natureza_trabalhos.find(n => n.id === linha_kpi.natureza_id);
                        const classeObj = this.classes.find(c => c.ID === linha_kpi.classe_id);

                        if (!materialObj || !naturezaObj || !classeObj) return;

                        // Verifica se já existe na lista (evita duplicados)
                        const exists = resultado.some(r =>
                            r.material.id === materialObj.id &&
                            r.natureza.id === naturezaObj.id &&
                            r.classe.ID === classeObj.ID
                        );

                        let quantidade = null

                        if (!exists) {
                            resultado.push({
                                material: materialObj,
                                natureza: naturezaObj,
                                classe: classeObj,
                                producao: linha_kpi.producao,
                                qty: null
                            });
                        }
                    }
                });
            });

            return resultado;
        },
        groupedMaterials() {
            const agrupado = {};

            this.getMaterialsList.forEach(entry => {
                const classe = entry.classe?.Descricao || 'Sem Classe';
                const natureza = entry.natureza?.natureza || 'Sem Natureza';
                const material = entry.material;
                const producao = entry.producao;

                if (!agrupado[classe]) {
                agrupado[classe] = {};
                }

                if (!agrupado[classe][natureza]) {
                agrupado[classe][natureza] = [];
                }

                // Adiciona material + produção no array
                agrupado[classe][natureza].push({
                    descricao: material.descricao,
                    classe: entry.classe,
                    natureza: entry.natureza,
                    material: entry.material,
                    id: material.id,
                    producao: producao,
                    unidade: material.unidade_base,
                    qty: entry.qty
                });
            });

            return agrupado;
        },
        groupedSubempreitadas(){
            const agrupado = {};

            this.getSubempreitadasList.forEach(entry => {
                const classe = entry.classe?.Descricao || 'Sem Classe';
                const natureza = entry.natureza?.natureza || 'Sem Natureza';
                const subempreitada = entry.subempreitada;
                const producao = entry.producao;

                if (!agrupado[classe]) {
                    agrupado[classe] = {};
                }

                if (!agrupado[classe][natureza]) {
                    agrupado[classe][natureza] = [];
                }

                // Adiciona subempreitada + produção no array
                agrupado[classe][natureza].push({
                    descricao: subempreitada.Descricao,
                    classe: entry.classe,
                    natureza: entry.natureza,
                    subempreitada: entry.subempreitada,
                    id: subempreitada.Id,
                    producao: producao,
                    qty: entry.qty
                });
            });

            return agrupado;
        },
        getLines(){
            return this.line
        },
        showNature(){
            let returner = true
            this.obras.forEach(element => {
                if(this.fields.obra_id == element.Id){
                    if (new Date(element.DataCriacao) >= new Date('2024-09-01'))
                        returner = false
                }
            });
            return returner
        }
    }
}
</script>
<style>
.v-text-field__slot label,input{
    font-size: 13px !important;
}

.v-list-item__title{
    font-size: 13px !important;
}

.v-select__slot label,input{
    font-size: 13px !important;
}
</style>